import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { asyncCheckDuplicate, renderInput } from 'src/components/misc/redux-form-helpers';
import { Entities, TOMCAT_URL } from 'src/common/index';
import { isBlank, isEmailInvalid } from 'src/components/misc/validations';

class SchoolEditForm extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
    }

    render() {
        const { handleSubmit, school, isCreate, t } = this.props;

        return (
            <form className="form-horizontal" onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-6">
                        <Field name="name" label={`${t('schools.name')} *`} component={renderInput} />
                    </div>
                    <div className="col-md-6">
                        <Field name="type" label={`${t('schools.type')}`} component={renderInput} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <Field name="contactData.email" label={`${t('schools.email')}`} component={renderInput} />
                    </div>
                    <div className="col-md-6">
                        <Field name="contactData.phone" label={`${t('schools.telephone')}`} component={renderInput} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <Field
                            name="contactData.street"
                            label={`${t('contact_data.street')}`}
                            component={renderInput}
                        />
                    </div>
                    <div className="col-md-6">
                        <Field
                            name="contactData.postCode"
                            label={`${t('contact_data.post_code')}`}
                            component={renderInput}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <Field name="contactData.city" label={`${t('contact_data.city')}`} component={renderInput} />
                    </div>
                </div>
                {!isCreate && (
                    <div className="row">
                        <div className="col-md-6">
                            <Field
                                name="bonusPointsGranted"
                                label={t('schools.points.granted')}
                                type="number"
                                component={renderInput}
                            />
                        </div>
                        <div className="col-md-6">
                            <Field
                                name="bonusPointsRedeemed"
                                label={t('schools.points.redeemed')}
                                type="number"
                                component={renderInput}
                            />
                        </div>
                    </div>
                )}
            </form>
        );
    }
}

const validate = (values, props) => {
    const { t } = props;
    const errors = {
        contactData: {},
    };

    if (values.bonusPoints == null) errors.bonusPoints = t('error_missing.fill_in');
    else if (values.bonusPoints < 0) errors.bonusPoints = t('error_hint.error_negative');

    if (isBlank(values.name)) errors.name = t('error_missing.fill_in_name');
    if (values.contactData) {
        if (isEmailInvalid(values.contactData.email) && !isBlank(values.contactData.email))
            errors.contactData.email = t('error_hint.error_invalid_email');
    }

    return errors;
};

const asyncValidate = (values, dispatch, props) => {
    return asyncCheckDuplicate(
        props.t,
        `${TOMCAT_URL}api/${Entities.SCHOOL.repository}/search/findByName?name=${encodeURIComponent(values.name)}`,
        values.id,
        'name',
    );
};

SchoolEditForm = reduxForm({
    form: 'schoolEditForm',
    validate,
    asyncValidate,
    asyncBlurFields: ['name'],
})(SchoolEditForm);

const selector = formValueSelector('schoolEditForm');

const mapStateToProps = (state, ownProps) => {
    const { school, isCreate } = ownProps;

    let initialValues = {};

    if (!isCreate && school) {
        initialValues = {
            id: school.id,
            bonusPoints: school.bonusPoints,
            name: school.name,
            type: school.type,
            contactData: {
                email: school.contactData.email,
                phone: school.contactData.phone,
                street: school.contactData.street,
                postCode: school.contactData.postCode,
                city: school.contactData.city,
            },
            bonusPointsGranted: school.bonusPointsGranted,
            bonusPointsRedeemed: school.bonusPointsRedeemed,
        };
    }

    return {
        initialValues,
    };
};

SchoolEditForm = connect(mapStateToProps, null, null, { withRef: true })(SchoolEditForm);

export default SchoolEditForm;
